import { literal, union } from "superstruct";

const ReviewsSortingOptionsSchema = union([
    literal("mostRelevant"),
    literal("mostRecent"),
    literal("highestRating"),
    literal("lowestRating"),
    literal("withPhotos"),
    literal("mostHelpful"),
]);

export default ReviewsSortingOptionsSchema;
